// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RepeatIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RepeatIcon" ref={forwardedRef} {...props}>
      <path d="m5.372 15 1.02 1.02-1.06 1.058-2.828-2.828 2.828-2.828 1.063 1.062-.998.998h10.605V11h1.5v3a1 1 0 0 1-1 1z" />
      <path d="m15.132 5-1.02-1.02 1.06-1.059L18 5.749l-2.828 2.829-1.063-1.062 1.02-1.02H4.002V9h-1.5V6a1 1 0 0 1 1-1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RepeatIcon = /* @__PURE__ */ Object.assign(RepeatIconComponent, {
  displayName: 'RepeatIcon',
});
